import { render, staticRenderFns } from "./Hierarquia.vue?vue&type=template&id=bb8fa520"
import script from "./Hierarquia.vue?vue&type=script&lang=js"
export * from "./Hierarquia.vue?vue&type=script&lang=js"
import style0 from "./Hierarquia.vue?vue&type=style&index=0&id=bb8fa520&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports